import { Flex, Typography } from "antd"
import { useNavigate } from "react-router"

import ButtonComponent from "../../../../../Components/Button"
import Icon from "../../../../../Icon"

const { Text } = Typography

const Empty = () => {
  const navigate = useNavigate()
  return (
    <Flex
      style={{
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: 400
      }}
    >
      <Text type="secondary">
        You don’t have any referrals yet.
        <br />
        Go to the Invite tab to refer people.
      </Text>
      <ButtonComponent
        type={"primary"}
        onClick={() => navigate("?id=Invite")}
        className={"invite-btn"}
        text={"Invite people"}
      >
        <Icon type="arrow_right" />
      </ButtonComponent>
    </Flex>
  )
}

export default Empty
